import { useState, useEffect } from "react"
import axios from "axios"
import { Controller } from "react-hook-form"
import { Field, NativeSelect } from "@chakra-ui/react"

export default function SelectField({ control, rules, name, value, options, label, help, adapter, showEmpty }) {
    const [opts, setOpts] = useState(typeof options === "string" ? [] : options)

    useEffect(() => {
        if (typeof options === "string") {
            const getOpts = async () => {
                const { data: rawOptions } = await axios.get(options)
                let _opts = []
                if (adapter) {
                    _opts = adapter(rawOptions)
                } else {
                    _opts = rawOptions
                }
                setOpts(_opts)
            }
            getOpts()
        } else {
            setOpts(options)
        }
    }, [options])

    // hide any select field with no options
    if (typeof options === "object" && !options.length && !showEmpty) return null

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || ""}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Field.Label htmlFor={name}>{label}</Field.Label>
                        <NativeSelect.Root {...field}>
                            <NativeSelect.Field placeholder="Select">
                                {opts.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </NativeSelect.Field>
                        </NativeSelect.Root>
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                    </Field.Root>
                )
            }}
        />
    )
}
